export default __webpack_public_path__ + "static/media/KronaOne.97c7e647.ttf";